module.exports = __webpack_public_path__ + "img/excellentSet.9b2d7e14.png";